<template>
  <div id="app">
      <!-- Header -->
    <nav class="navbar navbar-light">
      <div class="container">
        <router-link class="navbar-brand" to="/"> 
          <img alt="EBS Logo" src="./assets/EBS2.png" style="display:inline;vertical-align:middle; height:50px"> 
          <span> | Saludos </span>
          
        </router-link>
        <ul class="nav navbar-nav pull-xs-right">
          <li class="nav-item">
            <router-link
              class="nav-link"
              active-class="active"
              exact
              to="/add"
            >           <img alt="Give Saludos" src="./assets/cheers.png" style="display:inline;vertical-align:middle; height:50px">
Give Saludos
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
<!--
    <nav class="navbar navbar-light">
      <router-link to="/" class="navbar-brand">Saludos</router-link>
      <div class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link to="/add" class="nav-link">Give Saludos</router-link>
        </li>
      </div>
    </nav>-->

    <div class="container mt-3">
      <router-view />
    </div>

    <!-- Footer -->
    <div style="padding-top: 50px;">
      <footer>
        <div class="container mt-3">
          <span class="attribution">
            © 2022 EBS-Saludos. All rights reserved. Made with ❤️ by the EBS DevOps x SQA Team.
            <br/><br/>
          </span>
        </div>
      </footer>
    </div>    

  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
@import '../public/css/main.css';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.navbar {
  background-color: #3b8e6d;
  text-align: center;
}

a {
  color: #000000;
  text-decoration: none;
}
</style>
